import en_US from '../locales/en-US';
import zh_CN from '../locales/zh-CN';
import ja from '../locales/ja';
var messages = {
    'en-US': en_US,
    'zh-CN': zh_CN,
    'ja': ja,
};
export default function localizeRules(locale) {
    if (!(locale in messages)) {
        locale = 'zh-CN';
    }
    var localized = messages[locale];
    return {
        required: { required: true, trigger: 'blur', message: localized['required'] },
        filled: { required: true, trigger: 'blur', message: localized['filled'] },
        notEmpty: { required: true, trigger: 'input+blur', message: localized['notEmpty'] },
        empty: { trigger: 'input+blur', message: localized['empty'] },
        minLength: { trigger: 'blur', message: localized['minLength'] },
        maxLength: { trigger: 'blur', message: localized['maxLength'] },
        rangeLength: { trigger: 'blur', message: localized['rangeLength'] },
        min: { trigger: 'blur', message: localized['min'] },
        max: { trigger: 'blur', message: localized['max'] },
        range: { trigger: 'blur', message: localized['range'] },
        pattern: { trigger: 'input+blur', message: localized['pattern'] },
        is: { trigger: 'blur', message: localized['is'] },
        isNot: { trigger: 'blur', message: localized['isNot'] },
        equals: { trigger: 'blur', message: localized['equals'] },
        notEquals: { trigger: 'blur', message: localized['notEquals'] },
        confirmed: { validate: 'is', trigger: 'blur', message: localized['confirmed'] },
        includes: { trigger: 'input+blur', message: localized['includes'] },
        excludes: { trigger: 'input+blur', message: localized['excludes'] },
        included: { trigger: 'input+blur', message: localized['included'] },
        excluded: { trigger: 'input+blur', message: localized['excluded'] },
        unique: { validate: 'excluded', trigger: 'blur', message: localized['unique'] },
        noDuplicates: { trigger: 'input+blur', message: localized['noDuplicates'] },
        string: { trigger: 'input+blur', message: localized['string'] },
        number: { trigger: 'input+blur', message: localized['number'] },
        numeric: { trigger: 'input+blur', message: localized['numeric'] },
        integer: { trigger: 'input+blur', message: localized['integer'] },
        decimal: { trigger: 'blur', message: localized['decimal'] },
        boolean: { trigger: 'input+blur', message: localized['boolean'] },
        function: { trigger: 'input+blur', message: localized['function'] },
        object: { trigger: 'input+blur', message: localized['object'] },
        plainObject: { trigger: 'input+blur', message: localized['plainObject'] },
        array: { trigger: 'input+blur', message: localized['array'] },
        alpha: { trigger: 'input+blur', message: localized['alpha'] },
        alphaNum: { trigger: 'input+blur', message: localized['alphaNum'] },
        alphaDash: { trigger: 'input+blur', message: localized['alphaDash'] },
        alphaNumDash: { trigger: 'input+blur', message: localized['alphaNumDash'] },
        alphaSpaces: { trigger: 'input+blur', message: localized['alphaSpaces'] },
        lowerCase: { trigger: 'input+blur', message: localized['lowerCase'] },
        upperCase: { trigger: 'input+blur', message: localized['upperCase'] },
        '^az': { trigger: 'input+blur', message: localized['^az'] },
        '^az09': { trigger: 'input+blur', message: localized['^az09'] },
        '^az09_': { trigger: 'input+blur', message: localized['^az09_'] },
        '^azAZ': { trigger: 'input+blur', message: localized['^azAZ'] },
        '^azAZ09': { trigger: 'input+blur', message: localized['^azAZ09'] },
        '^azAZ09_': { trigger: 'input+blur', message: localized['^azAZ09_'] },
        'az09$': { trigger: 'blur', message: localized['az09$'] },
        'azAZ09$': { trigger: 'blur', message: localized['azAZ09$'] },
        '^09$': { trigger: 'input+blur', message: localized['^09$'] },
        '^az09$': { trigger: 'input+blur', message: localized['^az09$'] },
        '^az09-$': { trigger: 'input+blur', message: localized['^az09-$'] },
        '^az09-.$': { trigger: 'input+blur', message: localized['^az09-.$'] },
        '^azAZ09$': { trigger: 'input+blur', message: localized['^azAZ09$'] },
        '^azAZ09-$': { trigger: 'input+blur', message: localized['^azAZ09-$'] },
        '^azAZ09_$': { trigger: 'input+blur', message: localized['^azAZ09_$'] },
        '^azAZ09-_$': { trigger: 'input+blur', message: localized['^azAZ09-_$'] },
        'without--': { trigger: 'input+blur', message: localized['without--'] },
        'without__': { trigger: 'input+blur', message: localized['without__'] },
        email: { trigger: 'blur', message: localized['email'] },
        ip: { trigger: 'blur', message: localized['ip'] },
        ipRange: { trigger: 'blur', message: localized['ipRange'] },
        port: { trigger: 'blur', message: localized['port'] },
        url: { trigger: 'blur', message: localized['url'] },
        macAddress: { trigger: 'blur', message: localized['macAddress'] },
        md5: { trigger: 'blur', message: localized['md5'] },
        'ascii': { trigger: 'input+blur', message: localized['ascii'] },
        //'base32': { trigger: 'input+blur', message: localized['base32'] } as Rule,
        base64: { trigger: 'blur', message: localized['base64'] },
        byteLength: { trigger: 'input+blur', message: localized['byteLength'] },
        dataURI: { trigger: 'blur', message: localized['dataURI'] },
        //'magnetURI': { trigger: 'input+blur', message: localized['magnetURI'] } as Rule,
        divisibleBy: { trigger: 'blur', message: localized['divisibleBy'] },
        halfWidth: { trigger: 'input+blur', message: localized['halfWidth'] },
        fullWidth: { trigger: 'input+blur', message: localized['fullWidth'] },
        hash: { trigger: 'blur', message: localized['hash'] },
        hexColor: { trigger: 'blur', message: localized['hexColor'] },
        hex: { trigger: 'blur', message: localized['hex'] },
        //'identityCard': { trigger: 'input+blur', message: localized['identityCard']} as Rule,
        creditCard: { trigger: 'blur', message: localized['creditCard'] },
        fqdn: { trigger: 'blur', message: localized['fqdn'] },
        //'ipRange': { trigger: 'input+blur', message: localized['ipRange']} as Rule,
        ipOrFQDN: { trigger: 'blur', message: localized['ipOrFQDN'] },
        isbn: { trigger: 'blur', message: localized['isbn'] },
        issn: { trigger: 'blur', message: localized['issn'] },
        isin: { trigger: 'blur', message: localized['isin'] },
        iso8601: { trigger: 'blur', message: localized['iso8601'] },
        //'rfc3339': { trigger: 'blur', message: localized['rfc3339'] } as Rule,
        iso31661Alpha2: { trigger: 'blur', message: localized['iso31661Alpha2'] },
        iso31661Alpha3: { trigger: 'blur', message: localized['iso31661Alpha3'] },
        json: { trigger: 'blur+input', message: localized['json'] },
        jwt: { trigger: 'blur', message: localized['jwt'] },
        latLong: { trigger: 'blur', message: localized['latLong'] },
        mobile: { trigger: 'blur', message: localized['mobile'] },
        mongoId: { trigger: 'blur', message: localized['mongoId'] },
        postalCode: { trigger: 'blur', message: localized['postalCode'] },
        uuid: { trigger: 'blur', message: localized['uuid'] },
        chinese: { trigger: 'input+blur', message: localized['chinese'] },
    };
}
//# sourceMappingURL=rules.js.map